import { FC } from 'react';
import { faFilePdf } from '~/assets';
import { If, UserInfoCard } from '~/components';
import { Icon, LoadingIndicator } from '~/modules';
import {
  ComplementsPt,
  EventTypesPt,
  fillStringIfEmpty,
  formatHourMinuteSecondDate,
  parseEnumToPt,
} from '~/utils';
import {
  ActionsTitle,
  Card,
  Container,
  Content,
  ContentColumn,
  DescriptionLabel,
  ExportPDFButton,
  Header,
  Label,
  SmallCard,
  SmallCardWrapper,
  UserInfoColumn,
  Wrapper,
} from './styles';

type Props = {
  log: ClientLog;
  clientDetailedInfo: ClientInfoList;
  clientName: string;
  isClientAppAccessBlocked: boolean;
  loading: boolean;
  onDownloadDetailedLog(): void;
};

const AuditDetails: FC<Props> = ({
  log,
  clientDetailedInfo,
  clientName,
  isClientAppAccessBlocked,
  loading,
  onDownloadDetailedLog,
}) => {
  return (
    <Wrapper titlePage="Detalhes da ação">
      <Container>
        <Header>
          <ActionsTitle>Detalhes da ação</ActionsTitle>

          <ExportPDFButton
            onPress={onDownloadDetailedLog}
            id="export_pdf_button"
          >
            <Icon icon={faFilePdf} fontSize={16} /> Exportar PDF
          </ExportPDFButton>
        </Header>
        <Content>
          <UserInfoColumn>
            <UserInfoCard
              clientDetailedInfo={clientDetailedInfo}
              clientName={clientName}
              isClientAppAccessBlocked={isClientAppAccessBlocked}
            />
          </UserInfoColumn>
          <ContentColumn>
            <Card>
              <Label>EVENTO</Label>
              <SmallCardWrapper>
                <SmallCard>
                  <Label>Data</Label>
                  <DescriptionLabel>
                    {formatHourMinuteSecondDate(new Date(log.createdAt))}
                  </DescriptionLabel>
                </SmallCard>

                <SmallCard>
                  <Label>Evento realizado</Label>
                  <DescriptionLabel>
                    {parseEnumToPt(log.eventType, EventTypesPt)}
                  </DescriptionLabel>
                </SmallCard>
                <SmallCard>
                  <Label>Complemento</Label>
                  <DescriptionLabel>
                    {parseEnumToPt(log.complement, ComplementsPt) ||
                      log.complement}
                  </DescriptionLabel>
                </SmallCard>

                <SmallCard>
                  <Label>ID do dispositivo</Label>
                  <DescriptionLabel>
                    {fillStringIfEmpty(log.deviceId)}
                  </DescriptionLabel>
                </SmallCard>
              </SmallCardWrapper>
            </Card>

            <If condition={!!(log.metadata && log.metadata.length > 0)}>
              <Card>
                <Label>DETALHES</Label>
                <SmallCardWrapper>
                  <If condition={loading}>
                    <LoadingIndicator />
                  </If>
                  <If condition={!loading}>
                    {log.metadata?.map(({ key, value }, index) => (
                      <SmallCard key={index}>
                        <Label>{key}</Label>
                        <DescriptionLabel>{value}</DescriptionLabel>
                      </SmallCard>
                    ))}
                  </If>
                </SmallCardWrapper>
              </Card>
            </If>
          </ContentColumn>
        </Content>
      </Container>
    </Wrapper>
  );
};

export default AuditDetails;
